<!-- eslint-disable vue/require-v-for-key -->
<template>
  <base-modal
    id="product-detail"
    size="modal-detail"
    title=" "
    :show="show"
    @closed="close()"
  >
    <template v-if="product">
      <div class="main">
        <div v-if="product.images.length >= 4">
          <div class="image-selector">
            <div :class="{ 'hidden': imageIndex == 0, 'image-scroll': true, 'arrow' : true }" @click="scrollLeft()">
              <base-icon icon="right-arrow-cell" style="transform: rotate(180deg);" />
            </div>
            <img class="image" :src="product.images[imageIndex].image_url">
            <div :class="{ 'hidden': imageIndex == product.images.length - 1, 'image-scroll': true, 'arrow' : true }" @click="scrollRight()">
              <base-icon icon="right-arrow-cell" />
            </div>
          </div>
          <div class="d-flex" style="margin: 5px 40px 0px 40px;">
            <div v-for="(n, i) in 4" @click="myMethod(imageIndex + i)">
              <img
                class="image image-carousel" :src="product.images[imageIndex + i].image_url"
              >
            </div>
          </div>
        </div>
        <!-- not valid image product -->
        <div v-else>
          <div v-if="product.images.length == 0 " class="image-selector">
            <img class="image" src="/img/blank-product.png">
          </div>
          <div v-else>
            <img class="image" :src="product.images[imageIndex].image_url">
          </div>
          <div v-if="product.images.length > 1" class="d-flex">
            <div v-for="(n, i) in product.images.length" @click="myMethod(imageIndex + i)">
              <img
                class="image image-carousel-limit" :src="product.images[imageIndex + i].image_url"
              >
            </div>
          </div>
          <div v-else class="d-flex" style="margin: 5px 40px 0px 40px;">
            <div v-for="(n, i) in product.images.length" @click="myMethod(imageIndex + i)">
              <img
                v-if="product.images.length> 1"
                class="image image-carousel" src="/img/blank-product.png"
              >
              <div
                v-else class="image image-carousel" style="width: 115px;"
              />
            </div>
          </div>
        </div>

        <div>
          <div class="title">
            {{ product.title }}
          </div>
          <div v-if="product.sale_display" class="price">
            <span class="price__old">
              {{ product.formatted_price }}
            </span>
            <span class="price__sale"> {{ product.sale_display }}</span>
          </div>
          <div v-else>
            <div class="price">
              {{ product.formatted_price }}
            </div>
          </div>

          <div class="sku">
            ID: {{ product.external_id }}
          </div>
          <div v-if="product.detailed_color" class="section">
            <div class="section-title">
              Color:
            </div>
            <div class="section-body">
              {{ product.detailed_color }}
            </div>
          </div>
          <div v-if="product.size_info" class="section">
            <div class="section-title">
              Size:
            </div>
            <div class="section-body">
              {{ product.size_info }}
            </div>
          </div>

          <div v-if="product.stock_status" class="section">
            <div class="section-title">
              Stock Status
            </div>
            <div class="section-body">
              {{ product.stock_status }}
            </div>
          </div>
          <div class="section">
            <div style="display: flex; justify-content: space-between;">
              <div class="section-title mt-3">
                Description
              </div>
              <button
                data-toggle="collapse"
                data-target="#demo" style="border: none; background: none; margin-top:10px"
                @click="visibleDescrip = !visibleDescrip"
              >
                <base-icon icon="chevron-down-black" :style="`${ visibleDescrip ? 'transform: rotate(180deg)' : ''}`" />
              </button>
            </div>
            <div id="demo" class="section-body collapse show">
              <div v-html="product.description ? product.description : '-'" />
            </div>
            <hr>
          </div>
          <div class="section">
            <div class="section-title" style="font-size: 16px; font-family: 'SilkaMedium';">
              URL
              <base-text
                underline
                style="
                font-family: 'SilkaLight';
                cursor: pointer;
                float: right;
                font-size: 12px;"
                @click="onCopyLinkClicked"
              >
                Copy URL
              </base-text>
            </div>
            <div class="section-body">
              <a class="link" :href="product.site_url" target="_blank">{{ product.site_url }}</a>
              <input id="site-url" type="hidden" :value="product.site_url">
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
export default {
  name: 'CatalogProductDetailModal',
  props: {
    product: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
    },
  },
  data: () => ({
    imageIndex: 0,
    visibleDescrip: true,
  }),
  methods: {
    onCopyLinkClicked() {
      const testingCodeToCopy = document.querySelector('#site-url');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    close() {
      this.visibleDescrip = true;
      this.imageIndex = 0;
      this.$emit('closed');
    },
    scrollLeft() {
      this.imageIndex--;
    },
    scrollRight() {
      this.imageIndex++;
    },
    myMethod(ssps) {
      this.imageIndex = ssps;
    },

  },
};
</script>

<style lang="scss" scoped>
  .hidden {
    visibility: hidden;
  }
  .arrow {
    background-color: unset !important;
  }

  .main {
    display: flex;
    margin-top: 12px;
    margin-bottom: 12px;

    & > * {
      flex: 1;

      &:not(:first-child) {
        margin-left: 10px;
      }
      &:not(:last-child) {
        margin-right: 26px;
      }
    }
  }

  .image {
    max-width: 100%;
    min-width: 0;
  }

  .link:hover {
    background-color: transparent;
  }

  .image-selector {
    display: flex;
    flex-direction: row;

    & > * {

      &:not(:first-child) {
        margin-left: 10px;
      }
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .image-scroll {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;

    &:hover {
      background: #f7f7f7;
    }
  }

  .link {
    margin-top: 30px;
  }

  .title {
    font-family: Tiempos;
    font-size: 27px;
    font-weight: 600;
    margin-bottom: 12px;
    line-height: 32.4px;
  }

  .section-title {
    font-family: 'SilkaMedium';
    font-size: 14px;
    margin-bottom: 8px;

  }
  .section-body {
    font-family: 'SilkaLight';
    font-size: 14px;
    margin-bottom: 10px;
  }

  .section {
    padding-bottom: 16px;
    padding-top:8px;
  }

  .price {
    font-family: 'SilkaLight';
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 12px;
    &__old{
      text-decoration: line-through;
    }
    &__sale{
      margin-left: 4px;
    }
  }
  .sku {
    margin-bottom: 24px;
  }
  .sku {
    color: #767676;
    font-family: 'SilkaLight';
    font-weight: 300;
    font-size: 0.75rem;
  }
  ::v-deep .modal-header{
    background-color: unset;
    z-index: 9999;
    border-bottom: none;
    .close {
      padding: 20px 22px 14px 0px;
    }
  }
  ::v-deep .modal-body{
    padding: unset;
    margin: -20px 56px 50px 56px !important;
  }
  .image-carousel{
    max-width: 111.5px;
    padding: 5px;
    cursor: pointer;
  }
  .image-carousel-limit{
    max-width: 111.5px;
    padding-top: 10px;
    padding-right: 10px;
    cursor: pointer;
  }
</style>
